import { render, staticRenderFns } from "./withdrawal.vue?vue&type=template&id=b378ab34&scoped=true&"
import script from "./withdrawal.vue?vue&type=script&lang=js&"
export * from "./withdrawal.vue?vue&type=script&lang=js&"
import style0 from "./withdrawal.vue?vue&type=style&index=0&id=b378ab34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b378ab34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b378ab34')) {
      api.createRecord('b378ab34', component.options)
    } else {
      api.reload('b378ab34', component.options)
    }
    module.hot.accept("./withdrawal.vue?vue&type=template&id=b378ab34&scoped=true&", function () {
      api.rerender('b378ab34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/merchantMy/withdrawal.vue"
export default component.exports